export default __webpack_public_path__ + "static/media/Confectionery2.21b09ca1.png";